module.exports = __webpack_public_path__ + "media/assets/images/flags/tn-458c5122de2ae8fe7186b58ca7d39da5.svg";